<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Include A State</h4>
    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancel()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="evenly">
    @for (st of data.states; track st) {
    <mat-checkbox
      (change)="onStateClick($event, st)"
      [checked]="st === data.selected"
      >{{st}}</mat-checkbox
    >
    }
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onCancel()"
      mat-dialog-close
      class="button-close"
    >
      Close
    </button>
  </div>
</div>
